import icon from '@/assets/icon.png';
import wechatjt from '@/assets/wechatjt.png';
import apple from '@/assets/apple.png';
import android from '@/assets/android.png';
import safe from '@/assets/safe.png';
import mores from '@/assets/mores.png';
import down_back from '@/assets/down_back.png';
import safari from '@/assets/safari.png';
import point from '@/assets/point.png';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default {
  name: 'DownPage',

  setup() {
    const route = useRoute();
    const router = useRouter();
    const isWechat = ref(false);
    const show = ref(false);
    const isIos = ref(false);
    const userAgent = navigator.userAgent.toLowerCase();
    const match = userAgent.match(/MicroMessenger/i);

    if (match !== null && match.toString() === 'micromessenger') {
      isWechat.value = true;
    }

    const toApple = () => {
      if (isWechat.value) {
        show.value = true;
      } else {
        router.push({
          name: 'apple'
        });
      }
    };

    const close = () => {
      show.value = false;
    };

    const down = () => {
      if (isWechat.value) {
        show.value = true;
      } else {
        if (route.params.code !== undefined && route.params.code !== '') {
          window.location.href = 'https://api.mianjuyuehui.net/web-api/index/download/' + route.params.code;
        } else {
          window.location.href = 'https://www.mianjuyuehui.net/download/androidRelease.apk';
        }
      }
    };

    onMounted(() => {// const u = navigator.userAgent
      // const isAndroid = userAgent.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
      // const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      // if (!isWechat.value && !isAndroid && !isIOS) {
      //   window.location.href = 'https://www.mianjuyuehui.net/web-download'
      // }
    });

    const toH5 = () => {
      window.location.href = 'https://www.mianjuyuehui.net/h5';
    };

    return {
      icon,
      down,
      wechatjt,
      isWechat,
      show,
      apple,
      android,
      safe,
      mores,
      down_back,
      safari,
      isIos,
      close,
      toApple,
      point,
      toH5
    };
  }

};